import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';

var _templateObject;
var Input = styled('input')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 12px;\n  font-size: 1rem;\n  min-width: 100%;\n  color: ", ";\n  border: solid 2px\n    ", ";\n  border-radius: 2px;\n  background-color: ", ";\n  &:focus {\n    outline: none;\n    border: solid 2px ", ";\n    box-shadow: ", ";\n  }\n\n  &:not(:focus) ~ #helper-text {\n    display: none;\n  }\n\n  &:focus ~ #error-message {\n    display: none;\n  }\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themes["default"] : _ref$theme;
  return theme.palette.black;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    error = _ref2.error;
  return error ? theme.palette.errorDark : theme.palette.gray;
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes["default"] : _ref3$theme;
  return theme.palette.white;
}, function (_ref4) {
  var _ref4$theme = _ref4.theme,
    theme = _ref4$theme === void 0 ? themes["default"] : _ref4$theme;
  return theme.palette.secondary;
}, function (_ref5) {
  var _ref5$theme = _ref5.theme,
    theme = _ref5$theme === void 0 ? themes["default"] : _ref5$theme;
  return theme.boxShadow.buttonFocus;
});
var _Input = withDefaultTheme(/*#__PURE__*/memo(Input));

export default _Input;
